import React from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "../../styles/styles.module.scss";

const ThankYouStage = ({ thankyouOptions = { goToSrpFunction: null } }) => {
  return (
    <div className={cl(classes.Form, classes.IntroStage)}>
      <h1>Thank you</h1>
      {thankyouOptions && thankyouOptions.isCorpie && (
        <p>
          Thank you for submitting your event brief. Our Event Expert will be in
          touch shortly.
        </p>
      )}
      {(!thankyouOptions || !thankyouOptions.isCorpie) && (
        <p>
          Thank you for submitting your event brief. Our Event Expert will be in
          touch shortly.
        </p>
      )}
      <p>
        Did you know VenueScanner are now also specialising in Virtual Events
        for everything from Christmas Parties to Birthdays.{" "}
        <a target="_blank" href="https://www.venuescanner.com/virtual-events">
          Find out more here
        </a>
      </p>
      {thankyouOptions && thankyouOptions.goToSrpFunction && (
        <p>
          <button
            type="button"
            className="cta"
            onClick={thankyouOptions.goToSrpFunction}
          >
            Check our search now
          </button>
        </p>
      )}
    </div>
  );
};

ThankYouStage.propTypes = {
  thankyouOptions: PropTypes.object,
};
export default ThankYouStage;
